import { useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";

// Lightweight SEO: sets document title + meta description + lang attribute per page.
export default function useSeo(titleDe, titleFr, descDe, descFr) {
  const { lang } = useLanguage();
  useEffect(() => {
    const title = lang === "fr" ? titleFr : titleDe;
    const desc = lang === "fr" ? descFr : descDe;
    document.title = `${title} · Our Promise Events`;
    document.documentElement.lang = lang;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc || "");
  }, [lang, titleDe, titleFr, descDe, descFr]);
}
